/**
 * Equalize heights of headings and text boxes in application process steps
 * Groups items by row and sets equal heights within each row
 */
function equalizeApplicationStepHeights() {
  const containers = document.querySelectorAll('.com-application-process__content.border');
  
  containers.forEach(container => {
    const items = Array.from(container.querySelectorAll('.single-application-step.border'));
    
    if (items.length === 0) return;
    
    // Reset heights first
    items.forEach(item => {
      const heading = item.querySelector('h3');
      const textBox = item.querySelector('.single-application-step__text');
      
      if (heading) heading.style.height = 'auto';
      if (textBox) textBox.style.height = 'auto';
    });
    
    // Group items by row based on their offsetTop
    const rows = [];
    let currentRow = [];
    let lastTop = -1;
    
    items.forEach(item => {
      const top = item.offsetTop;
      
      if (top !== lastTop) {
        if (currentRow.length > 0) {
          rows.push(currentRow);
        }
        currentRow = [item];
        lastTop = top;
      } else {
        currentRow.push(item);
      }
    });
    
    if (currentRow.length > 0) {
      rows.push(currentRow);
    }
    
    // Equalize heights within each row
    rows.forEach(rowItems => {
      let maxHeadingHeight = 0;
      let maxTextHeight = 0;
      
      // Find maximum heights
      rowItems.forEach(item => {
        const heading = item.querySelector('h3');
        const textBox = item.querySelector('.single-application-step__text');
        
        if (heading) {
          maxHeadingHeight = Math.max(maxHeadingHeight, heading.offsetHeight);
        }
        if (textBox) {
          maxTextHeight = Math.max(maxTextHeight, textBox.offsetHeight);
        }
      });
      
      // Apply maximum heights
      rowItems.forEach(item => {
        const heading = item.querySelector('h3');
        const textBox = item.querySelector('.single-application-step__text');
        
        if (heading && maxHeadingHeight > 0) {
          heading.style.height = maxHeadingHeight + 'px';
        }
        if (textBox && maxTextHeight > 0) {
          textBox.style.height = maxTextHeight + 'px';
        }
      });
    });
  });
}

// Run on DOM load
document.addEventListener('DOMContentLoaded', equalizeApplicationStepHeights);

// Run on window resize (debounced)
let resizeTimer;
window.addEventListener('resize', function() {
  clearTimeout(resizeTimer);
  resizeTimer = setTimeout(equalizeApplicationStepHeights, 250);
});

// Run when fonts are loaded (fixes issues with web fonts)
if (document.fonts) {
  document.fonts.ready.then(equalizeApplicationStepHeights);
}
